module.exports = __webpack_public_path__ + "img/step4.338d4a88.jpg";